import {Component, Input, OnInit} from '@angular/core';
import {environment} from "../../../environments/environment";
import {ClassicType} from "../../shared/models/ClassicType";
import {Subscription} from "rxjs";
import {CalendarEventAction} from "angular-calendar";
import {Scadenza} from "../../Scadenzario/Models/Scadenza";
import {EditScadenzaComponent} from "../../Scadenzario/edit-scadenza/edit-scadenza.component";
import {RmaStoreService} from "../../rma/_services/rma-store.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ScadenzeStoreService} from "../../Scadenzario/_services/scadenze-store.service";
import {ApiRestService} from '../_service/api-rest.service';
import {ApiRestService as ScadApirest} from "../../Scadenzario/_services/api-rest.service";
import {DomSanitizer, Title} from "@angular/platform-browser";
import {CalendarItem} from "../models/calendar-item";
import {Task} from "../models/Task";
import {Filtri} from "../models/filtri";
import {Permission} from "../../Login/_guards/Permission";
import {Rma} from "../../rma/_Models/rma";
import {Persona} from "../../Admin/models/persona";
import {PersonaleStoreService} from "../../Admin/_service/personale-store.service";
import {Paginazione} from "../../shared/models/paginazione";
import {CampoUtility} from "../../shared/models/campo-aggiuntivo";
import { TaskService } from '../_service/task.service';
import { TranslateService } from '@ngx-translate/core';
import { RmaProdottoAddComponent } from 'src/app/rma/rma-add/rma-prodotto-add.component';
import { IDropdownSettings } from 'src/LibrerieCustom/MultiselectDropdown';
import { Calendar } from 'angular-feather/icons';

@Component({
  selector: 'app-calendario',
  templateUrl: './calendario.component.html'
})
export class CalendarioComponent implements OnInit {
  env = environment;
  dropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField:'id',
    textField: 'label',
  };
  userdropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField:'id',
    textField: 'fullName',
    searchPlaceholderText: 'Cerca',
    allowSearchFilter: true,
    allowRemoteDataSearch: true
  };
  typedropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    singleOutput: true,
    idField: 'id',
    textField: 'label',
  };
  subdropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'label',
  };
  subFilter: any[];
  @Input() subFilterSel: any[] = [];
  Persone: Persona[] = [];
  PersoneSelezionate: Persona[] = [];
  TipiSelezionati: ClassicType[] = [];
  Tipi: ClassicType[] = [];
  filtrife:ClassicType[] = environment.filtrife;
  filtrifeSel:ClassicType[] = [{id:"T", label: "Tutti"}]
  subscriptions: Subscription = new Subscription();
  filtro: Filtri = new Filtri();
  scadenze: Task[] = [];
  collectionSize: number = 0;
  events: CalendarItem[] = [];
  title: string;
  CalendarType

  constructor(
    private RmaStore: RmaStoreService,
    private ApiRestService: ApiRestService,
    private modalService: NgbModal,
    private scadenzeStore: ScadenzeStoreService,
    private ScadenzeApiRestService: ScadApirest,
    protected sanitizer: DomSanitizer,
    public permission: Permission,
    private personaleStore: PersonaleStoreService,
    private translate: TranslateService,
    private campoUtility: CampoUtility,
    private titleService: Title,
    private TaskService: TaskService
  ) { }

  ngOnInit() {
    this.Refresh(new Date());
    if(environment.Modules.Scadenzario)
      this.scadenzeStore.getTipi();
    this.subscriptions.add(this.scadenzeStore.$tipi.subscribe(data => {
      this.Tipi = data ?? [];
    }))
    if(this.permission.hasOperativeRole('AZ'))
      this.personaleStore.getListaPersonale(new Paginazione(0,100));
    this.subscriptions.add(this.personaleStore.$listaPersonale.subscribe(data=> this.Persone = data?.data));
  }
  Refresh(value?: Date) {
    if (value) {
      this.filtro.anno = value.getFullYear();
      this.filtro.mese = value.getMonth() + 1;
    }
    var sel = this.subFilterSel.find(x => true);
    console.log("Calendar Type: ", this.CalendarType)
    var filter = this.TaskService.GetTaskFilter(this.filtrifeSel[0]?.id, sel?.id, null, this.filtro, null, this.PersoneSelezionate?.find(x => true)?.id, false, this.CalendarType)
    delete filter.DynamicTaskSettings;
    delete filter.datepipe;
    delete filter.inizio;
    delete filter.fine;
    this.ApiRestService.GetCalendarData(filter, true).subscribe(data => { 
      var result = this.TaskService.processCalendarData(data, this.filtrifeSel[0]?.id, sel?.id);
      if (this.CalendarType && this.CalendarType['feFilter']) {
        result.tasks = result.tasks.filter(x => this.CalendarType['feFilter'](x));
      }
      this.scadenze = result.tasks;
      this.collectionSize = result.collectionSize;
      this.events = this.CreateCalendarItems(result.tasks);
    })
  }
  
  private static HasIDs(oggetto: any[], ids: any[] ): boolean{
    let presente: boolean = false;
    ids?.forEach(id => presente = (presente == true ? true : oggetto?.find(x=>x?.id.toLocaleUpperCase() == id.toLocaleUpperCase()) != undefined))
    return presente;
  }
  private static HasTypes(oggetto: string, ids: any[] ): boolean{
    let presente: boolean = false;
    ids?.forEach(id => (presente = presente == true ? true : oggetto?.toLocaleUpperCase() == id.toLocaleUpperCase()))
    return presente;
  }

  filtrifechng() {
    if (!this.filtrifeSel || this.filtrifeSel.length == 0 || !this.filtrifeSel[0]) {
      this.filtrifeSel = [{id: "T", label: "Tutti"}]
    }
    this.titleService.setTitle(this.filtrifeSel[0].label && this.filtrifeSel[0].id != "T" ? this.translate.instant(this.filtrifeSel[0].label) : "Calendario");
    this.subFilterSel = [];
    this.subFilter = this.filtrifeSel[0]['SubFilter'] ?? [];
    this.Refresh(new Date())
  }

  subFiltrifechng() {
    var sel: {
      id: string | number,
      label: String,
      capacita: [],
      module: string,
      fieldnotexist: string[],
      fieldexist: string[]
    } = this.subFilterSel.find(x => true);
    console.log(sel)
    this.Refresh(new Date());

  }
  TipoCambiato() {
    this.filtro.tipo = undefined;
    if(this.TipiSelezionati && this.TipiSelezionati.length > 0 && this.TipiSelezionati[0])
      this.filtro.tipo = this.TipiSelezionati[0].id;
    this.Refresh(new Date())
  }

  private CreateCalendarItems(data: Task[]): CalendarItem[]{
    const Eventi: CalendarItem[] = [];
    var filterCalendarTask = environment.TaskAddon['CalendaTaskFilter'] ? environment.TaskAddon['CalendaTaskFilter'](data, this.filtro) : data;
    filterCalendarTask?.forEach(element => {
      if(CalendarioComponent.HasIDs(this.filtrifeSel, ["T", element.type]) && element.abilitata != false) {
        var calendaritem = this.GetCalendarItem(element);
        if(environment.TaskAddon['calendarHeaderField']){
          calendaritem.title = this.campoUtility.getValueStringFromArray(environment.TaskAddon['calendarHeaderField'], element);
        }
        Eventi.push(calendaritem);
      }
    });
    return Eventi;
  }
 
  private actions(): CalendarEventAction[] {
    return  [
      {
        label: '<span class="badge badge-info ml-1"><i class="ti-pencil"></i></span>',
        a11yLabel: 'Edit',
        onClick: ({ event }: { event: CalendarItem }): void => {
          this.EditButton(event)
        },
      }
    ];
  }
  private actionsWithDelete(): CalendarEventAction[] {
    return [
      {
        label: '<span class="badge badge-info ml-1"><i class="ti-pencil"></i></span>',
        a11yLabel: 'Edit',
        onClick: ({ event }: { event: CalendarItem }): void => {
          this.EditButton(event)
        },
      },
      {
        label: '<span class="badge badge-danger ml-1"><i class="ti-trash"></i></span>',
        a11yLabel: 'Delete',
        onClick: ({ event }: { event: CalendarItem }): void => {
          this.DeleteButton(event)
        },
      }
    ];
  }
  private static getRmaColor(rma:Rma): string{
    if(environment.TaskAddon['ColoriCalendario']){
      var color ;
      environment.TaskAddon['ColoriCalendario']?.forEach(colore =>{
        if( (colore?.fieldexist && rma[colore?.fieldexist]) ||
          (colore?.fieldnotexist && !rma[colore?.fieldnotexist]) ||
          (colore?.arrayEmpty && (!rma[colore?.arrayEmpty] || rma[colore?.arrayEmpty]?.length >= 0)) ||
          (colore?.arrayFull && rma[colore?.arrayFull]?.length>0))
          color = colore.colore;
      })
      return color;
    }
    if(rma.chiuso)
      return '#6DA447';
    if(rma.data_fine_effettiva)
      return '#F6BE30'
    if (rma.data_apertura_centro)
      return '#758fef'
    if(rma.assistenzaId)
      return '#50270A'
    return '#E95A3B'

  }
  private static getScadenzaColor(task:Task): string{
    return task.chiuso && task.manager ? '#3cb043' : task.manager ? '#e1e100' : '#ff0000';
  }
  private static getFaseColor(task:Task): string{
    return task.data_fine_effettiva && task.manager ? '#3cb043' : task.manager || task.data_fine_effettiva ? '#e1e100' : '#ff0000';
  }
  private static getAttivitaColor(task:Task): string{
    return task.chiuso? '#3cb043' : '#ff0000';
  }

  DeleteButton(event) {
    if(!isNaN(<number>event.id))
      switch (event.type.toLocaleUpperCase()) {
        case "S":
          if (confirm("Sei sicuro di voler eliminare questo elemento? ")) {
            this.ScadenzeApiRestService.deleteScadenza(event).subscribe(data => {
              this.Refresh(new Date(this.filtro.anno, this.filtro.mese-1))
            });
          }
          break;
        case "F": //fasi
          break;
        case "A": //taskboard
          break;
        case "L": //lezioni
          break;
        case "B": //spese
          break;
        case "I": //fatture
          break;
        case "C": //CRM
          break;
        case "V": //Valutazione
          break;
      }
  }
  EditButton(event: CalendarItem) {
    if (isNaN(<number>event.id)) return;
    this.TaskService.OpenFromTask(event.task, () => {
      this.Refresh(new Date(this.filtro.anno, this.filtro.mese-1));
    })
  
  }
  AggiungiScadenza() {
    this.scadenzeStore.updateScadenzaSelezionata(new Scadenza());
    const editmodal = this.modalService.open(EditScadenzaComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<EditScadenzaComponent>editmodal.componentInstance).IsModal = true;
    (<EditScadenzaComponent>editmodal.componentInstance).added.subscribe(data=>{this.Refresh(new Date(this.filtro.anno, this.filtro.mese-1));});
    (<EditScadenzaComponent>editmodal.componentInstance).updated.subscribe(data=> {});
  }

  getPermission(type: string):boolean {
    switch (type.toLocaleUpperCase()) {
      case "R":
        return true;
      case "S":
        return true;
      case "F": //fasi
        return this.permission.isPermitted('gestione-fasi') || this.permission.hasOperativeRoles(['RF', 'PM', 'PF'])
      case "A": //attivita cliente
        return true;
      case "L": //lezioni
        return true;
      case "B": //spese
        return true;
      case "I": //fatture
        return true;
      case "C": //attivita cliente
        return true;
      case "V": //valutazioni
        return true;
      case "W":
        return true;
      case "N": //news
        return true;
    }
    return true;
  }
  AggiungiRma() {
    const editmodal = this.modalService.open(RmaProdottoAddComponent, {centered: true, backdrop: 'static', size: 'xl',});
    const _newRma = new Rma();
    // _newRma.data_inizio_prevista = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.RmaStore.updateSelected(_newRma);
    (<RmaProdottoAddComponent>editmodal.componentInstance).onClose.subscribe(data => { this.Refresh(); })
  }

  private GetCalendarItem(task: Task): CalendarItem {
   
    var Item = {
      start: new Date(task.data_inizio_prevista),
      end: new Date(task.data_fine_prevista ? task.data_fine_prevista : task.data_inizio_prevista),
      title: task.nome,
      color: {
        primary: CalendarioComponent.getAttivitaColor(task),
        secondary: '#D1E8FF'
      },
      type: task.type,
      id: task.id,
      task: task
    }
    var dynamicFields = this.campoUtility.getDynamicTaskSctructure(task.type, task.tipo);
    if (dynamicFields && dynamicFields['CalendarMap']) {
      return Object.assign(Item, dynamicFields['CalendarMap'](task));
    }

    switch (task.type) {
      case "R": //rma
        return Object.assign(Item, {
          end: new Date( task.data_fine_prevista),
          title: environment.RmaAddOn['fieldProgressivo'] ?
            (task['padre'] ? 'Intervento' : this.translate.instant('RMA.title')) + " #" + (task[environment.RmaAddOn['fieldProgressivo']] ? task[environment.RmaAddOn['fieldProgressivo']]?.toString() : "") + " " + (task?.nome ?? '')
            : `Ticket # ${((task?.progressivo ?? task.id) ? (task?.progressivo ?? task.id)?.toString() : "") + " " + (task?.nome ?? '')}`,
          color: {
            primary: CalendarioComponent.getRmaColor(task),
            secondary: '#D1E8FF'
          },
        })
       
      case "S": // scadenze
        return Object.assign(Item, {
          title: task.nome + " " + task?.manager?.fullName,
          actions: this.getPermission(task.type) ? this.actionsWithDelete() : [],
          color: {
            primary: CalendarioComponent.getScadenzaColor(task),
            secondary: '#D1E8FF'
          },
        })
      case "F": //fasi
        return Object.assign(Item, {
          title: task.nome + " " + task?.manager?.fullName,
          color: {
            primary: CalendarioComponent.getFaseColor(task),
            secondary: '#D1E8FF'
          },
        })
      case "A": //attivita cliente
        return Object.assign(Item, {
          color: {
            primary: CalendarioComponent.getFaseColor(task),
            secondary: '#D1E8FF'
          },
        })
    }
    return Object.assign(Item, { })
  }



}
